import { IqamaTransfer } from './iqama-transfer';
import { VisaPreApproval } from './visa-pre-approval';
import { CommonService } from 'src/app/core/common.service';
import { BusinessVisa } from './business-visa';
import { ExitPermission } from './exit-permission';
import { GosiAddition } from './gosi-addition';
import { GOSIRemoval } from './gosi-removal';
import { EmploymentVisa } from './employment-visa';
import { IqamaIssuance } from './iqama-issuance';
import { IqamaRenewal } from './iqama-renewal';
import { ExitIqamaTransfer } from './exit-iqama-transfer';
import { VisaCancellation } from './visa-cancellation';
import { PassportInfoUpdate } from './passport-info-update';
export {
    IqamaTransfer,
    VisaPreApproval,
    CommonService,
    BusinessVisa,
    ExitPermission,
    GosiAddition,
    IqamaIssuance,
    IqamaRenewal,
    ExitIqamaTransfer,
    VisaCancellation,
    GOSIRemoval,
    EmploymentVisa,
    PassportInfoUpdate
};
